import { TablePagination } from '@components/common/TablePagination';

interface DocumentsPagerProps {
  idPrefix?: string;
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

export const DocumentsPager = ({
  idPrefix = 'documents',
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
}: DocumentsPagerProps) => {
  return <TablePagination idPrefix={idPrefix} page={page} pageSize={pageSize} total={total} onPageChange={onPageChange} onPageSizeChange={onPageSizeChange} />;
};

export default DocumentsPager;
